import useTranslation from 'next-translate/useTranslation';
import { createStyles } from '@mantine/core';
import { BRANDS, BRAND_NAMES } from '~/domains/auth/consts';

import { Title } from '~/domains/design-system/Title';
import { SplashLogo, LogoTypes } from '~/components/shared/Logos/SplashLogo';
import { OFPLogoThumbnail } from './OFPLogoThumbnail';
import { RYPLogoThumbnail } from './RYPLogoThumbnail';

const useStyles = createStyles((theme) => ({
  EOCalloutWrapper: {
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'stretch',
    minHeight: 68,
    maxWidth: 420,
    borderRadius: theme.radius.md,
    padding: theme.other.spacing._16,
    gap: theme.other.spacing._16,
    marginBottom: theme.other.spacing._32,
    marginTop: theme.other.spacing._32,
    borderColor: theme.colors.gray2[1],
    borderWidth: 1,
    borderStyle: 'solid',
  },
  iconsContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  iconBox: {
    height: 30,
    width: 30,
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    background: theme.colors.gray2[6],
    borderRadius: theme.radius.md,
    borderColor: theme.white,
    borderWidth: '1.75px',
    borderStyle: 'solid',
    padding: 0,
  },
  iconEOBox: {
    marginTop: -theme.other.spacing._6,
  },
  iconOFPBox: {
    background: theme.colors.ofpBlue,
  },
  iconSplashBox: {
    marginLeft: -theme.other.spacing._4,
    marginTop: theme.other.spacing._6,
    zIndex: 4,
  },
}));

type EOCalloutProps = {
  brand: BRANDS;
};

export function EOCallout({ brand }: EOCalloutProps) {
  const { t } = useTranslation('auth');
  const { classes, cx } = useStyles();

  return (
    <div className={classes.EOCalloutWrapper}>
      <div className={classes.iconsContainer}>
        {brand === BRANDS.RYP ? (
          <div className={cx(classes.iconBox, classes.iconEOBox)}>
            <RYPLogoThumbnail size={21} />
          </div>
        ) : (
          <div className={cx(classes.iconBox, classes.iconEOBox, classes.iconOFPBox)}>
            <OFPLogoThumbnail size={25} />
          </div>
        )}
        <div className={cx(classes.iconBox, classes.iconSplashBox)}>
          <SplashLogo type={LogoTypes.PRIMARY_NO_TEXT} withoutLink size={9} />
        </div>
      </div>
      <Title variant="title-small" c="gray2.6">
        {t('signUp.eoCallout', { eoBrandName: BRAND_NAMES[brand] })}
      </Title>
    </div>
  );
}
